// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    ActivityChildrenActualHours_Text: 'Zeitprotokolle für alle Unteraktivitäten:',
    ActivityChildrenEstimatedHours_Text: 'Geschätzte Stunden für alle Unteraktivitäten:',
    ActivityOwnBudget_Text: 'Budget für die Aktivität:',
    ActivityOwnEstimatedHours_Text: 'Geschätzter Stundenaufwand für die Aktivität:',
    ActivitySubactivitiesBudget_Text: 'Budget für alle Unteraktivitäten:',
    ActualCompletion_Text: 'Tatsächlicher Abschluss',
    ActualHours_Total_Text: 'Tatsächlich aufgewendete Stunden, gesamt:',
    AddTimeEntry_Text: 'Zeiteintrag hinzufügen',
    AddUser_Text: 'Benutzer einladen',
    Apply: 'Anwenden',
    Assignees_Text: 'Bearbeiter',
    BudgetedCost_Text: 'Gesamtprojektbudget:',
    BudgetTotal_Text: 'Budget, gesamt:',
    Cancel: 'Abbrechen',
    Close: 'Schließen',
    Combobox_Add: 'Hinzufügen ',
    Combobox_KeepTyping: 'Weiter eingeben ...',
    Combobox_NoResults: 'Keine Ergebnisse',
    Combobox_NoResultsMatch: 'Keine Ergebnisse für ',
    Cost_Text: 'Kosten:',
    CreateAndSelect: 'Erstellen und auswählen',
    CustomerLabel: 'Kunde',
    Duration_Text: 'Dauer',
    EditProjectMembers_Title: 'Projektmitglieder',
    EditTaskAssignees_Title: 'Beautragten',
    End_Text: 'Ende',
    EndDate_Text: 'Enddatum',
    EstimatedHours_Text: 'Geschätzter Stundenaufwand',
    EstimatedHours_Total_Text: 'Geschätzter Stundenaufwand, gesamt:',
    Hours_Short_Text: 'Std',
    HoursLeftLabel: 'Verbleibende Stunden:',
    InternalCost_Text: 'Interne Kosten:',
    NonProjectMembers_Text: 'Keine Projektmitglieder',
    Overloaded_Text: 'Überlastet',
    OwnActualHours_Text: 'Zeitprotokolle für die Aktivität:',
    PlannedExpenses_Text: 'Geplante Ausgaben:',
    PortfolioLabel: 'Portfolio',
    Progress: 'Fortschritt',
    ProgressCalculatedBySubActivities: 'Auf Basis des Fortschritts der Unteraktivitäten',
    ProjectChildrenActualHours_Text: 'Zeitprotokolle für die Aktivität:',
    ProjectChildrenEstimatedHours_Text: 'Geschätzte Stunden für alle Aktivitäten:',
    ProjectMembers_Text: 'Projektmitglieder',
    ProjectOwnBudget_Text: 'Budget für das Projekt:',
    ProjectOwnEstimatedHours_Text: 'Geschätzter Stundenaufwand für das Projekt:',
    ProjectSubactivitiesBudget_Text: 'Budget für alle Aktivitäten:',
    Start_Text: 'Beginn',
    StartDate_Text: 'Startdatum',
    Teams_Text: 'Teams',
    Tooltip_ItemCompleted: 'Datum nicht bearbeitbar, da an ein/e geschlossene/s Aktivität/Projekt gekoppelt',
    Untitled: 'Unbenannt',
    Validation_ActComplDateRange: 'Tatsächliches Abschlussdatum fällt nicht in erwarteten Bereich.',
    Validation_DateMandatory: 'Datum erforderlich.',
    Validation_DurationMandatory: 'Dauer ist ein Pflichtfeld.',
    Validation_EndDateRange: 'Enddatum fällt nicht in erwarteten Bereich.',
    Validation_FieldMandatory: 'Dieses Feld ist erforderlich.',
    Validation_FromDateRange: 'Startdatum fällt nicht in erwarteten Bereich.',
    Validation_Interger: 'Wert muss integer sein.',
    Validation_InvalidDate: 'Datum muss Format \'{0}\' aufweisen.',
    Validation_NumberRange: 'Wert muss zwischen {0} und {1} sein',
    Validation_Range: 'Wert ist nicht im erwarteten Rahmen.',
    Validation_StartDateRange: 'Startdatum fällt nicht in erwarteten Bereich.',
    Validation_ToDateRange: 'Enddatum fällt nicht in erwarteten Bereich.',
    Validation_WeekendOrVacation: 'Wert darf nicht auf ein Wochenende oder einen Feiertag fallen.',
    Warning_UnassigneFromAllTasksInProject: 'Entfernte Mitglieder werden von allen Aktivitäten dieses Projekts deaktiviert.',
};
